import { isRTL } from 'core/services/language';
import ReCAPTCHA from 'react-google-recaptcha';
import React, { forwardRef } from 'react';

interface RecaptchaProps {
	onSubmit: (token: string | null) => void;
	onExpired?: () => void;
	centered?: boolean;
	style?: React.CSSProperties;
}

const Recaptcha = forwardRef<ReCAPTCHA, RecaptchaProps>(({ onSubmit, onExpired, centered, style }, ref) => {
	return (
		<ReCAPTCHA
			hl={isRTL() ? 'ar' : 'en'}
			style={{
				margin: centered ? '20px auto' : '20px 0',
				width: 'max-content',
				...style,
			}}
			onChange={(token) => onSubmit(token)}
			sitekey={process.env['REACT_APP_RECAPTCHA_SITE_KEY'] as string}
			onExpired={onExpired}
			ref={ref}
		/>
	);
});

export default Recaptcha;
